var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chats-container"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('chats'),expression:"'chats'"}],staticClass:"d-lg-none m-t-15",attrs:{"block":"","variant":"primary"}},[_vm._v(" Buscar chat ")]),_c('div',{staticClass:"d-none d-lg-block"},[_c('chat-search'),_c('chats-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }